import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "tw-absolute tw-text-start tw-m-0 tw-pointer-events-none tw-overflow-hidden tw-h-[47px] -tw-top-5px tw-right-0 tw-bottom-0 tw-left-0 tw-px-2 tw-py-0 tw-border tw-border-dashed tw-border-w-secondary tw-rounded-xs"
};
var _hoisted_2 = {
  "class": "tw-float-none tw-w-auto tw-overflow-hidden tw-block tw-p-0 tw-text tw-ml-2 tw-h-3 tw-invisible tw-max-w-full tw-whitespace-nowrap"
};
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = {
  "class": "upload-file-input tw-w-full tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-h-[42px] tw-bg-w-lavender tw-rounded-xs"
};
var _hoisted_5 = ["id", "multiple", "accept"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_BaseFloatingLabel = _resolveComponent("BaseFloatingLabel");
  return _openBlock(), _createElementBlock("div", {
    "class": _normalizeClass(["base-upload-file-wrapper tw-relative", [{
      'mt-10': _ctx.withMargin
    }, _ctx.$attrs["class"]]])
  }, [_createElementVNode("fieldset", _hoisted_1, [_createElementVNode("legend", _hoisted_2, [_createElementVNode("span", {
    "class": "tw-px-5px tw-visible tw-inline-block tw-opacity-0",
    innerHTML: _ctx.labelText
  }, null, 8 /* PROPS */, _hoisted_3)])]), _ctx.labelText ? (_openBlock(), _createBlock(_component_BaseFloatingLabel, {
    key: 0,
    "class": _normalizeClass(_ctx.$attrs['floating-label-classes']),
    "label-text": _ctx.labelText,
    "label-state": "floating-label"
  }, null, 8 /* PROPS */, ["class", "label-text"])) : _createCommentVNode("v-if", true), _createElementVNode("label", _hoisted_4, [_createElementVNode("input", {
    id: _ctx.$attrs.id,
    multiple: _ctx.$attrs.multiple,
    type: "file",
    "class": "tw-hidden",
    accept: _ctx.$attrs.accept,
    onInput: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      return _ctx.handleInput && _ctx.handleInput.apply(_ctx, arguments);
    })
  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5), _renderSlot(_ctx.$slots, "label", {
    filename: _ctx.filename
  })])], 2 /* CLASS */);
}